import { combineReducers } from 'redux';

import clientList from './clientList/reducer';
import clientView from './clientView/reducer';

export default combineReducers({
  clientList,
  clientView,
});
